import api from "@/plugins/api";
export async function createOrganisationRelation(organisationId, payload) {
    await api.post(`/organisations/${organisationId}/relations`, payload, { unwrapEnvelope: true });
}
